<template>
  <v-container>
    <LoginRequired/>
    <LoadingIndicator
        :loading="isLoading"/>
    <ErrorDialog
        :show="showError"
        :errorContent="errorContent"/>
    <v-alert
        color="primary"
        elevation="24"
        icon="mdi-information-outline"
        type="info"
    >
      Komplette Palette / Lagerplatz von {{ selectedFromCode ? selectedFromCode.name : '...' }} nach
      {{ selectedToCode ? selectedToCode.name : '...' }} einlagern
    </v-alert>
    <VerticalSpacer/>

    <template v-if="!isLoading">
      <v-select
          v-model="selectedFromCode"
          :items="warehouses"
          item-value="code"
          item-text="name"
          label="Von"
          solo
          return-object
      ></v-select>

      <v-select
          v-model="selectedToCode"
          :items="warehouses"
          item-value="code"
          item-text="name"
          label="Nach"
          solo
          return-object
      ></v-select>
      <VerticalSpacer/>
      <VerticalSpacer/>

      <div class="sticky-confirm-wrapper">
        <v-btn
            color="success"
            elevation="2"
            large
            block
            :disabled="!selectedFromCode || !selectedToCode"
            :to="{name: 'rearrange.entire_bin_location.select_bin_location_from', params: {
              from: selectedFromCode ? selectedFromCode.code : 'unknown',
              to: selectedToCode ? selectedToCode.code : 'unknown'
            }}"
        >Bestätigen
        </v-btn>
      </div>
    </template>
  </v-container>
</template>

<script>
import LoginRequired from "../../Others/LoginRequired";
import LoadingIndicator from "../../Others/LoadingIndicator";
import ErrorDialog from "../../Others/ErrorDialog";
import VerticalSpacer from "../../Others/VerticalSpacer";

export default {
  components: {VerticalSpacer, ErrorDialog, LoadingIndicator, LoginRequired},
  data: () => ({
    isLoading: true,
    warehouses: null,
    showError: false,
    errorContent: '',
    selectedFromCode: null,
    selectedToCode: null
  }),
  created() {
    this.$axios.get('warehouses').then(response => {
      if (response && response.data && response.data.data) {
        this.warehouses = response.data.data;
        this.preselectToWarehouse();
      } else {
        this.showError = true;
        this.errorContent = response.data.message;
      }
      this.isLoading = false;
    });
  },

  methods: {
    preselectToWarehouse() {
      const mainWarehouse = this.warehouses.find(warehouse => warehouse.code === 'L');
      if (mainWarehouse) {
        this.selectedToCode = mainWarehouse;
      }
    }
  }
}
</script>

<style scoped>
.sticky-confirm-wrapper {
  position: sticky;
  bottom: 0;
  z-index: 5;
  padding-top: 8px;
  padding-bottom: calc(8px + env(safe-area-inset-bottom));
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff 20px);
}
</style>
